import './AddressesPage.scss'

import { useLocation } from 'react-router-dom'

import AddAddressForm from '../../../components/add-address-form/AddAddressForm'

const AddAddressPage = () => {
  const location = useLocation()
  const adres = location.state?.adres

  return (
    <div className="addresses-page">
      <AddAddressForm adres={adres} />
    </div>
  )
}

export default AddAddressPage
